module.exports = __webpack_public_path__ + "img/office-1.fd3c1e68.jpg";